@if (accommodationData != null) {
    <div class="PGProductHostAccommodation">
        <div class="PGProductHostAccommodation-Prop" pdfgen="line">
            <span>{{ 'RESOURCES.Host.fields.accommodation_type.label' | locTranslate }}</span>
            @if (accommodationData.accommodation_type != null && accommodationData.accommodation_type != null) {
                <b >{{ 'OPTIONMAPS.Host.accommodation_type.' + accommodationData.accommodation_type | locTranslate }}</b>
            }
        </div>
        <div pdfgen="line" class="mt-3" [innerHTML]="getAccommodationDescription()"></div>
        @if (getAccommodationServices(); as services) {
            <div pdfgen="line" [innerHTML]="services"></div>
        }
        @if (getAccommodationPrices(); as prices) {
            <hr/>
            <div class="PGProductHostAccommodation-Prop" pdfgen="line">
                <span>{{ 'RESOURCES.Host.fields.accommodation_prices.label' | locTranslate }}</span>
                <b [innerHTML]="prices"></b>
            </div>
        }
    </div>
}